import { Injectable } from '@angular/core';
import { Plant } from 'src/app/data-models/plant';
import { throwError, Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlantService {
    private plantsUrl = 'api/plants';

    constructor(private http: HttpClient, ) { }
    getPlants(): Observable<Plant[]> {
        return this.http.get<Plant[]>(this.plantsUrl + '/GetPlants')
            .pipe(
                tap(data => JSON.stringify(data)),
                catchError(this.handleError)
            );
    }

    getPlant(id: number): Observable<Plant> {
        if (id === 0) {
            return of(this.initializePlant());
        }
        const url = `${this.plantsUrl}/${id}`;

        return this.http.get<Plant>(url)
            .pipe(
                tap(data => JSON.stringify(data)),
                catchError(this.handleError)
            );
    }

    createPlant(plant: Plant): Observable<Plant> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        plant.id = null;
        return this.http.post<Plant>(this.plantsUrl + '/SavePlant', JSON.stringify(plant), { headers })
            .pipe(
                tap(data => console.log('createPlant: ' + JSON.stringify(data))),
                catchError(this.handleError)
            );
    }

    deletePlant(id: number): Observable<{}> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = `${this.plantsUrl}/${id}`;
        return this.http.delete<Plant>(url, { headers })
            .pipe(
                tap(data => console.log('deletePlant: ' + id)),
                catchError(this.handleError)
            );
    }

    updatePlant(plant: Plant): Observable<Plant> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = `${this.plantsUrl}/${plant.id}`;
        return this.http.put<Plant>(url, plant, { headers })
            .pipe(
                tap(() => console.log('updatePlant: ' + plant.id)),
                // Return the field on an update
                map(() => plant),
                catchError(this.handleError)
            );
    }

    private handleError(err) {
        debugger;
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage: string;
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err.status}: ${err.message}`;
        }
        console.error(err);
        return throwError(errorMessage);
    }

    private initializePlant(): Plant{
        // Return an initialized object
        return {
            id: 0,
            name: null,
            description: null,
            plantTypeId: null
            
        };
    }
}

